import React, { Component } from "react"
import { connect } from 'react-redux'

import {
    getVendorListAction,
} from '../../redux/actions/MasterAction'

import {
    updateMR_DetailAction,
} from '../../redux/actions/MRAction'

import {
    updateEvaluationModalAction,
} from '../../redux/actions/MRAction'

import {
    setInputAction,
} from '../../redux/actions/ModalVendorAction'

import { msg } from '../../components/Notifications/MsgBox';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";

import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"
class SearchIRVendorModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            vendors: [],
            q_vendorCode:'',
            q_vendorName:'',
            result_vendors:[],
            page: 0,
            rowsPerPage: 5,
            totalRecord:0,
            order: "asc",
            orderBy: "",
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)

    }

    handleChange(event) {
        const { name, value } = event.target
        this.setState({
            [name]: value,
        })

        this.props.setInput(name, value);

    }

    async handleClick(event, newPage){
        this.props.startLoading()

        let {q_vendorCode,q_vendorName,vendors,page,rowsPerPage} = this.state;
        //let result_vendors = vendors.filter(v => v.vendoR_CODE.indexOf(q_vendorCode) !== -1 && v.vendoR_NAME1.indexOf(q_vendorName) !== -1)
        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }
        await this.props.getVendor(q_vendorName,q_vendorCode,page*rowsPerPage,rowsPerPage)
        .then(response => {
            if(response.data !== ""){
                this.setState({
                    result_vendors:response.data,
                    totalRecord:response && response.data[0] ?response.data[0].totaL_ROW:0,
                    page:page,
                    rowsPerPage: rowsPerPage
                })
            }else{
                this.setState({
                    result_vendors:[],
                    totalRecord:0,
                    page:page,
                    rowsPerPage: rowsPerPage
                })
            }
        });    

        this.props.stopLoading()
        // this.props.setInput('q_vendorCode', q_vendorCode);
        // this.props.setInput('q_vendorName', q_vendorName);
        // this.props.setInput('result_vendors', result_vendors);
        
        if(this.state.result_vendors.length === 0){
            msg.error("ไม่พบข้อมูล")
        }
    }



    chooseItem(item){
        window.$('#searchIRVendorModal').modal('hide')
        window.onSelectVendor(item)
    }

    componentDidMount() {

        // this.props.getVendor()
        // .then((response)=>{this.setState({vendors : response.data})})
    } 

    // Grid start
    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        if (typeof (array) !== "undefined") {
            const stabilizedThis = array.map((el, index) => [el, index]);
            stabilizedThis.sort((a, b) => {
                const order = cmp(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
            return stabilizedThis.map(el => el[0]);
        }
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy === property && this.state.order === "desc";
        this.setState({
            order: isDesc ? "asc" : "desc",
            orderBy: property
        })
    }

    async handleChangePage(event, newPage) {
        await this.setState({
            page: newPage
        })
        this.handleClick(event, newPage)
    }

    async handleChangeRowsPerPage(event) {
        await this.setState({
            rowsPerPage: event.target.value,
            page: 0
        })
        this.handleClick()
    }

    render() {

        let {
            result_vendors,
            q_vendorCode,
            q_vendorName,
            totalRecord
        } = this.state;

        q_vendorCode = (q_vendorCode ? q_vendorCode :"");
        q_vendorName = (q_vendorName ? q_vendorName :"");

        return (
            <div className="modal fade sp-modal rrs-modal" id="searchIRVendorModal" tabIndex={-1} role="dialog" aria-labelledby="searchIRVendorModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchIRVendorModalLabel">ค้นหาข้อมูลผู้ค้า</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container">
                            <div className="rrs-detail3">
                                <div className="row">
                                    <div className="col-3">
                                        <div className="rrs-form">

                                            <label htmlFor="txtEmpCode" className="rrs-label">รหัสผู้ค้า</label>
                                            <div className="rrs-detail-data">
                                                <input type="text" maxLength="8" className="form-control w-100"  placeholder="รหัสผู้ค้า" id="q_vendorCode" name="q_vendorCode"  onChange={this.handleChange} value={q_vendorCode} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="rrs-form">

                                            <label htmlFor="txtName" className="rrs-label">ชื่อผู้ค้า</label>
                                            <div className="rrs-detail-data">
                                                <input type="text" maxLength="20" className="form-control w-100"  placeholder="ชื่อผู้ค้า" id="q_vendorName" name="q_vendorName"  onChange={this.handleChange} value={q_vendorName} />
                                            </div>

                                        </div>
                                    </div>

                                   
                                    <div className="col-3">
                                        <div className="rrs-form">
                                            <label htmlFor="txtName" className="rrs-label" style={{marginBottom:'9px',width:'100%'}}>&nbsp;</label>
                                            <button className="rrs-btn-icon" onClick={this.handleClick}><i className="icon bt-search icon-xs"></i></button>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row no-gutters sp-table-content">
                                <div className="col-12">
                                    {/* <table className="sp-table table rrs-table-2">
                                            <thead>
                                                <tr className="sp-table-header">
                                                    <th className="th-table" width="20%"><div className="th-text">รหัสผู้ค้า</div></th>
                                                    <th className="th-table"><div className="th-text">ชื่อผู้ค้า</div></th>
                                                    <th className="th-table" width="20%"><div className="th-text">Action</div></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    result_vendors && result_vendors.map((datas, index) => (
                                                        <tr key={index}>
                                                            <td>{datas.vendoR_CODE}</td>
                                                            <td>{datas.vendoR_NAME1}</td>
                                                            <td>
                                                                <button className="btn btn-info btn-choose-item" data-dismiss="modal" aria-label="Close" onClick={() => this.chooseItem(datas)}>
                                                                    เลือก
                                                                </button>    
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table> */}

                                    
                                    <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                        <TableHead>
                                            <TableRow className="sp-table-header">
                                                <TableCell className="th-table text-center">
                                                    รหัสผู้ค้า
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    ชื่อผู้ค้า
                                                </TableCell>
                                                <TableCell className="th-table text-center">
                                                    
                                                </TableCell>
                                                
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {result_vendors && this.stableSort(result_vendors, this.getSorting(this.state.order, this.state.orderBy))
                                                //.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage)
                                                .map((row, index) => {
                                                    //console.log("SearchAssetModal", page)                                                    
                                                    //console.log(assetDatas)                                                    
                                                    return (
                                                        <TableRow
                                                            hover
                                                            tabIndex={-1}
                                                            key={row.vendoR_CODE}
                                                        >
                                                            <TableCell className="action-icon">
                                                                {row.vendoR_CODE}
                                                            </TableCell>
                                                            <TableCell className="action-icon text-left">
                                                                {row.vendoR_NAME1}
                                                            </TableCell>
                                                            <TableCell className="action-icon">
                                                                <button className="btn btn-info btn-choose-item" aria-label="Close" onClick={() => this.chooseItem(row)}>
                                                                    เลือก
                                                                </button> 
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        className="pager"
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={totalRecord}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.page}
                                        backIconButtonProps={{
                                            "aria-label": "previous page"
                                        }}
                                        nextIconButtonProps={{
                                            "aria-label": "next page"
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />

                                    </div>

                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux, ModalVendorRedux } = state
    return {
        vendors: MasterRedux.vendors,
        key_table: ModalVendorRedux.key_table,
        key_vendorCode: ModalVendorRedux.key_vendorCode,
        key_vendorName: ModalVendorRedux.key_vendorName,
        result_vendors: ModalVendorRedux.result_vendors,
        q_vendorCode: ModalVendorRedux.q_vendorCode,
        q_vendorName: ModalVendorRedux.q_vendorName,
        evaluationModal: MainRedux.evaluationModal,
        
        //t_MR_VENDOR:MainRedux.t_MR_VENDOR,
    }
}
  
  const mapDispatchToProps = dispatch => {
    return {
      updateEvaluationModal: (data, fieldName) => dispatch(updateEvaluationModalAction(data, fieldName)),
      setInput: (input_name, input_value) => dispatch(setInputAction(input_name, input_value)),
      getVendor : (vendorName, vendorCode, offset, limit) => dispatch(getVendorListAction(vendorName, vendorCode, offset, limit)),
      startLoading: () => dispatch(startLoadingAction()),
      stopLoading: () => dispatch(stopLoadingAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchIRVendorModal)